export function initCanny(user) {
  if (!window.Canny) {
    return;
  }

  window.Canny("identify", {
    appID: "670eb2973a7d58695eb713b6", // TODO:Oleh: shouldn't be ENV variable?
    user: {
      // Replace these values with the current user's data
      email: user.email,
      name: `${user.firstName} ${user.lastName}`,
      id: user.id,
    },
  });
}

export const openCannyAuthenticatedLink = (feedbackLink) => {
  const authenticatedLink = window.Canny("authenticateCannyLink", feedbackLink);
  window.open(authenticatedLink, "_blank", "noopener");
};
